import BaseModelAPI from '../BaseModelAPI';

export default class MappingAndonProdDetail extends BaseModelAPI {
	static entity = 'mappingandonproddetail';
	static entityName = 'mappingandonproddetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.mappingAndonProductionId = '';
			this.mappingAndonProduction = {};
			this.machineId = '';
			this.machine = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}